import { render, staticRenderFns } from "./PatternSetupNew.vue?vue&type=template&id=8f4cf316"
import script from "./PatternSetupNew.vue?vue&type=script&lang=js"
export * from "./PatternSetupNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports